  export const ENROLL_MOBILE_HID_READERS = "12"; // Used with HID readers
  export const ENROLL_MOBILE_STID_READERS = "28"; // Used with STid readers
  export const ENROLL_MOBILE_PROPRIETERY_HID = "29"; // Used with Impro mobile readers
  export const ENROLL_MOBILE_PROPRIETERY_STID = "30"; // Used with Impro mobile readers